import styles from './Header.module.css'

const HeaderComponent = () => {
  return (
    <header className={styles.header}>
      <h1>'인구 문제'의 과거, 현재, 미래</h1>
    </header>
  );
};

export default HeaderComponent;
